import { useQuery } from '@tanstack/react-query';
import { companyService } from '@/api/services/CompanyService';
import { useAuth } from '@/stores/authContext';

export const ALL_DOCUMENTS_QUERY_KEY = ['allDocuments'] as const;

// Документы аккредитации (server-state). Включены только при авторизации. Параметр enabled позволяет
// не слать этот относительно тяжёлый запрос там, где он не нужен (напр. на Главной — только когда
// действительно требуется признак сельхозтоваропроизводителя).
export function useAllDocuments(enabled = true) {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: ALL_DOCUMENTS_QUERY_KEY,
    queryFn: () => companyService.getAllDocuments(),
    enabled: isAuthenticated && enabled,
    staleTime: 60_000,
  });
}
